import { render, staticRenderFns } from "./MemberRegistrationDupeResult.vue?vue&type=template&id=5b8261e8&"
import script from "./MemberRegistrationDupeResultVue.ts?vue&type=script&lang=ts&"
export * from "./MemberRegistrationDupeResultVue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports